/* @flow */
export const getLocationsByIdEntities = (state: Object) => state.entities.locationsById;
export const getLocationsByGoogleIdEntities = (state: Object) => state.entities.locationsByGoogleId;

export const getLocationById = (state: Object, id: string) => {
  let locations = getLocationsByIdEntities(state);
  if (locations) return locations[id];
  else return null;
};

export const getLocationByGoogleId = (state: Object, googleId: string, address2: ?string) => {
  const locations = getLocationsByGoogleIdEntities(state) || {};
  return locations && locations[googleId] && locations[googleId][address2];
};



// WEBPACK FOOTER //
// ./src/redux/locations/selectors.js